export default __webpack_public_path__ + "assets/8a8ca58d1d7cef69f06e6e5e73749aee.woff";